import React, { } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useStore } from '../Store'

const YearFilter = () => {
    const {year, setYear, years}= useStore()

    return (
        <>
            <FormControl fullWidth={true}>
                <InputLabel id="label_jaar">Jaar</InputLabel>
                <Select
                    labelId="label_jaar"
                    id="select_jaar"
                    value={year}
                    onChange={(e) => setYear(e.target.value)}>
                    {years && years.length > 0 ?
                        years.map((item, i) => (
                            <MenuItem value={item.id} key={item.id}>{item.description}</MenuItem>
                        )) : null}
                </Select>
            </FormControl>
        </>
    )
}

export default YearFilter
